import React from 'react';
import cx from 'classnames';

import DefaultButton, { ButtonProps as DefaultButtonProps } from '../../Button';

import styles from './Button.module.scss';
import capitalize from '../../../utils/fns/capitalize';

export interface ButtonProps extends Omit<DefaultButtonProps, 'intent'> {
  /**
   * Specify the `Button`'s intent.
   * @default default
   */
  intent?: 'default' | 'prominent';
}

export const Button = ({
  appearance = 'solid',
  children,
  className,
  isLoading,
  disabled,
  intent = 'default',
  ...restProps
}: ButtonProps) => {
  const isProminent = intent === 'prominent';

  return (
    <DefaultButton
      className={cx(
        styles.button,
        appearance && styles[appearance],
        isLoading && styles.isLoading,
        disabled && styles.isDisabled,
        intent && styles[`intent${capitalize(intent)}`],
        className,
      )}
      appearance={appearance}
      isLoading={isLoading}
      disabled={disabled}
      intent={isProminent ? undefined : intent}
      icon={null}
      {...restProps}
    >
      {children}
    </DefaultButton>
  );
};

Button.displayName = 'Button';
export default Button;
export { styles };
